import Helpers from './helpers';

export default class PreviewUpload {
	constructor({ elements }) {
		elements.forEach((el) => {
			el.addEventListener('change', this.readFiles, false);
		});
	}

	readFiles() {
		const fileReader = new FileReader();
		fileReader.addEventListener(
			'load',
			() => {
				const insertNode = this.parentNode;
				const fileSize = this.files[0].size;
				if (insertNode.getElementsByClassName('text--error')[0])
					insertNode.getElementsByClassName('text--error')[0].remove();
				const uploadBtn = insertNode.querySelector('label');

				if (uploadBtn) {
					uploadBtn.innerText = this.dataset?.uploadOther || 'Upload other photo';
				}
				if (Helpers.bytesToMB(fileSize) > 8) {
					this.value = '';
					if (insertNode.querySelector('figure')) {
						insertNode.querySelector('figure').remove();
					}
					const errorMsg = document.createElement('P');
					errorMsg.innerText =
						this.dataset?.uploadErrorMsg || 'Upload another photo, this one is bigger than 8MB';
					errorMsg.classList.add('text--error', 'text--center', 'text--short');
					insertNode.insertBefore(errorMsg, insertNode.firstChild);
				} else {
					Helpers.renderPreview(insertNode, fileReader.result);
				}
			},
			false
		);
		if (this.files && this.files[0]) {
			fileReader.readAsDataURL(this.files[0]);
		}
	}
}
